<template>
    <div class="tab-content-wrap h-75">
        <div class="tab-content h-100">
            <div class="item-content h-100">
                <div class="access-sg text clearfix">
                    <div class="d-flex justify-content-between" style="border-bottom: 1px solid #282D69;">
                        <div class="title">
                            Attendees
                        </div>
                        <button type="button" class="btn btn-add-alt text-white" v-on:click="downloadCsv" :disabled="filteredAttendees.length < 1">EXPORT CSV</button>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <input class="attendee-search" type="text" v-model="searchText" placeholder="Search attendees..." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="table-responsive">
                                <table class="table bd-dark-blue" style="border-radius: 0 0 10px 10px;">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Company</th>
                                            <th>Facility / Site</th>
                                            <th>Email</th>
                                            <th>Number</th>
                                            <th>Employee ID</th>
                                            <th>ID / Passport</th>
                                            <th>Date</th>
                                            <th>Facilitator</th>
                                            <th>Deleted</th>
                                            <th v-if="hasCertificate"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="filteredAttendees.length < 1">
                                            <td colspan="11" class="text-center">No attendees found</td>
                                        </tr>
                                        <tr v-for="attendee in filteredAttendees" :key="attendee.id" v-bind:class="{ 'deleted-row': attendee.isDeleted }">
                                            <td>{{ attendee.name }} {{ attendee.surname }}</td>
                                            <td>{{ attendee.company }}</td>
                                            <td>{{ attendee.facilitySite }}</td>
                                            <td>{{ attendee.email }}</td>
                                            <td>{{ attendee.number }}</td>
                                            <td>{{ attendee.employeeId }}</td>
                                            <td>{{ attendee.idNumber }}</td>
                                            <td>{{ formatDate(attendee.date) }}</td>
                                            <td>{{ facilitatorName(attendee) }}</td>
                                            <td class="text-center">
                                                <input type="checkbox" v-model="attendee.isDeleted" v-on:change="updateDeleted(attendee)" />
                                            </td>
                                            <td v-if="hasCertificate">
                                                <button type="button" class="btn btn-add-alt text-white" v-on:click="downloadCertificate(attendee)">Certificate</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MixinsCertificates from '../../mixinsCertificates';

    export default {
        name: "AttendeesPage",
        mixins: [MixinsCertificates],
        props: ["initialAttendees", "initialCourse", "initialCourseDetails"],
        data() {
            return {
                attendees: this.initialAttendees == null ? [] : this.initialAttendees,
                course: this.initialCourse,
                courseDetails: this.initialCourseDetails,
                searchText: ""
            }
        },
        computed: {
            hasCertificate() {
                return !!this.courseDetails && !!this.courseDetails.certificateProperties && this.courseDetails.certificateProperties.length > 0;
            },
            filteredAttendees() {
                var search = this.searchText ? this.searchText.toLowerCase().trim() : "";
                if (!search) {
                    return this.attendees;
                }

                return this.attendees.filter(attendee => {
                    var values = [
                        attendee.name,
                        attendee.surname,
                        attendee.company,
                        attendee.facilitySite,
                        attendee.email,
                        attendee.number,
                        attendee.employeeId,
                        attendee.idNumber,
                        this.formatDate(attendee.date),
                        this.facilitatorName(attendee),
                        attendee.isDeleted ? "deleted" : "active"
                    ];

                    return values
                        .filter(x => x !== null && x !== undefined)
                        .some(x => x.toString().toLowerCase().indexOf(search) > -1);
                });
            }
        },
        watch: {
            initialAttendees: function (newVal, oldVal) {
                this.attendees = newVal == null ? [] : newVal;
            },
            initialCourse: function (newVal, oldVal) {
                this.course = newVal;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            },
        },
        methods: {
            formatDate(value) {
                if (!value) {
                    return "";
                }

                return value.toString().split("T")[0];
            },
            facilitatorName(attendee) {
                if (!attendee.user) {
                    return "";
                }

                var names = [attendee.user.firstName, attendee.user.lastName]
                    .filter(x => x)
                    .join(" ");

                return names || attendee.user.email || "";
            },
            csvValue(value) {
                if (value === null || value === undefined) {
                    return "";
                }

                return `"${value.toString().replace(/"/g, '""')}"`;
            },
            async updateDeleted(attendee) {
                var newValue = attendee.isDeleted;

                try {
                    await this.web("/courses/attendees/deleted/" + attendee.id, "Updating attendee", {
                        isDeleted: newValue
                    });
                }
                catch (e) {
                    attendee.isDeleted = !newValue;
                    throw e;
                }
            },
            async downloadCertificate(attendee) {
                var pdfBytes = await this.generateCertificate(this.course, this.courseDetails, null, attendee);
                var link = document.createElement("a");
                link.href = URL.createObjectURL(new Blob([new Uint8Array(pdfBytes)], { type: "application/pdf" }));
                link.download = `Certificate-${attendee.name}-${attendee.surname}.pdf`;
                link.click();
            },
            downloadCsv() {
                var headers = ["Name", "Surname", "Company", "Facility / Site", "Email", "Number", "Employee ID", "ID / Passport", "Date", "Facilitator", "Deleted"];
                var rows = this.filteredAttendees.map(attendee => [
                    attendee.name,
                    attendee.surname,
                    attendee.company,
                    attendee.facilitySite,
                    attendee.email,
                    attendee.number,
                    attendee.employeeId,
                    attendee.idNumber,
                    this.formatDate(attendee.date),
                    this.facilitatorName(attendee),
                    attendee.isDeleted ? "Yes" : "No"
                ]);

                var csv = [headers].concat(rows)
                    .map(row => row.map(this.csvValue).join(","))
                    .join("\r\n");

                var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                var link = document.createElement("a");
                var courseName = this.course && this.course.name ? this.course.name.replace(/[^a-z0-9]/gi, "-").toLowerCase() : "course";

                link.href = URL.createObjectURL(blob);
                link.download = `${courseName}-attendees.csv`;
                link.click();
                URL.revokeObjectURL(link.href);
            }
        }
    }
</script>

<style scoped>
    .attendee-search {
        border: 1px solid #d9dce7;
        border-radius: 4px;
        color: #222;
        height: 40px;
        margin-bottom: 15px;
        padding: 8px 10px;
        width: 100%;
    }

    .deleted-row {
        background-color: #f6f6f6;
        color: #777;
    }
</style>
